import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { LinkTo } from '@ember/routing';

interface ProfileHeaderSignature {
  Args: {
    visitorId: string;
    from: string;
    id: string;
  };
}

export default <template>
  <LinkTo
    @route="visitors.profiles.show"
    @model={{@visitorId}}
    @query={{hash from=@from id=@id}}
    class="btn btn--small btn--outlineFill"
    data-test-view-profile-link
  >
    View Profile
  </LinkTo>
</template> satisfies TOC<ProfileHeaderSignature>;
